__turbopack_context__.v({
  "container": "Video-module-scss-module__BUdJ_W__container",
  "mobileVideo": "Video-module-scss-module__BUdJ_W__mobileVideo",
  "video": "Video-module-scss-module__BUdJ_W__video",
});
